import React from 'react';
import GalleryView, { GalleryItem } from '../../components/Creative/GalleryView';
// Sample data for merchandise
const merchGalleryItems: GalleryItem[] = [{
  id: '1',
  imageUrl: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Book-Themed T-Shirt',
  creator: 'Literary Apparel Co.',
  price: 75,
  priceType: 'fixed',
  serviceType: 'Apparel Design',
  genre: ['Multiple'],
  description: "Custom t-shirt design based on your book's themes, characters, or quotes."
}, {
  id: '2',
  imageUrl: 'https://images.unsplash.com/photo-1541643600914-78b084683601?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Bookmark Collection',
  creator: 'Page Markers',
  price: 45,
  priceType: 'starting',
  serviceType: 'Bookmark Design',
  genre: ['Multiple'],
  description: 'Set of custom bookmarks featuring artwork inspired by your book.'
}, {
  id: '3',
  imageUrl: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Author Branding Package',
  creator: 'Brand Builders',
  price: 299,
  priceType: 'starting',
  serviceType: 'Branding Package',
  genre: ['Multiple'],
  description: 'Complete branding package including logo, business cards, and social media assets.'
}, {
  id: '4',
  imageUrl: 'https://images.unsplash.com/photo-1541643600914-78b084683601?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Book-Themed Candle',
  creator: 'Literary Scents',
  price: 60,
  priceType: 'fixed',
  serviceType: 'Candle Design',
  genre: ['Multiple'],
  description: 'Custom-scented candle with packaging inspired by your book.'
}, {
  id: '5',
  imageUrl: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Book Box Design',
  creator: 'Box Creatives',
  price: 180,
  priceType: 'starting',
  serviceType: 'Box Design',
  genre: ['Multiple'],
  description: 'Themed subscription box design for your book or series.'
}, {
  id: '6',
  imageUrl: 'https://images.unsplash.com/photo-1541643600914-78b084683601?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Enamel Pin Set',
  creator: 'Pin Wizards',
  price: 85,
  priceType: 'fixed',
  serviceType: 'Pin Design',
  genre: ['Multiple'],
  description: 'Set of enamel pins featuring symbols or characters from your book.'
}, {
  id: '7',
  imageUrl: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Tote Bag Design',
  creator: 'Literary Apparel Co.',
  price: 65,
  priceType: 'fixed',
  serviceType: 'Apparel Design',
  genre: ['Multiple'],
  description: 'Custom tote bag featuring artwork or quotes from your book.'
}, {
  id: '8',
  imageUrl: 'https://images.unsplash.com/photo-1541643600914-78b084683601?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Book Sleeve',
  creator: 'Page Protectors',
  price: 40,
  priceType: 'starting',
  serviceType: 'Fabric Design',
  genre: ['Multiple'],
  description: 'Protective sleeve for books with custom fabric design.'
}];
const MerchGallery = () => {
  return <GalleryView items={merchGalleryItems} title="Book Merchandise Gallery" categoryName="Book Merchandise" data-id="element-8622" data-mp="kgg7tqshm0nv" />;
};
export default MerchGallery;